module.exports = __webpack_public_path__ + "static/media/assistance-e-commerce.ebeb3ad2.jpg";